import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from '../../../_shared/services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CardService } from 'src/app/authenticated/services/card.service';
import { UserService } from 'src/app/authenticated/services/user.service';
import { Subject } from 'rxjs';
import { AdobeDtmService } from 'src/app/_shared/services/adobe-dtm.service';

@Component({
  selector: 'app-link-card',
  templateUrl: './link-card.component.html',
  styleUrls: ['./link-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LinkCardComponent implements OnInit {
  componentDestroyed = new Subject<void>();
  response: any;
  cardForm: FormGroup;
  error: string;
  errorFlag: boolean = false;
  aemContent: any;
  desktopImg: string;
  mobileImg: string;
  isLoading: boolean = false;
  hasCard: boolean = false;
  linkCardContent: any;
  digitalData: any;
  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private formbuilder: FormBuilder,
    private readonly adobeDTMService: AdobeDtmService
  ) {}

  linkCard = {
    nameOnCard: '',
    last4DigitsOfCard: '',
    zipCode: '',
    idToken: ''
  };

  ngOnInit(): void {
    this.getContent();
    this.cardForm = this.formbuilder.group({
      nameOnCard: ['', [Validators.required]],
      cardNumber: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
      zipCode: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]]
    });
    this.sendTrackingInfo();
    this.setAnalytics();
  }

  onSubmit() {
    this.errorFlag = false;
    this.isLoading = true;
    const idToken = this.route.snapshot.queryParamMap.get('id_token');

    if (this.cardForm.invalid || !idToken) {
      this.error =
        'Oops! It looks like an error happened, please refresh your page or try again later.';
      this.errorFlag = true;
      this.isLoading = false;
      return;
    }

    this.linkCard = {
      nameOnCard: this.cardForm.value.nameOnCard,
      last4DigitsOfCard: this.cardForm.value.cardNumber,
      zipCode: this.cardForm.value.zipCode,
      idToken: idToken
    };
    this.apiService.postLinkCard(this.linkCard).subscribe(result => {
      this.response = result;
      if (this.response.respCode === '200') {
        this.isLoading = false;
        const params = { ...this.route.snapshot.queryParams };
        delete params['id_token'];
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: params,
          replaceUrl: true
        });
        window.location.href = '/dashboard';
      } else {
        this.errorFlag = true;
        this.isLoading = false;
        this.error =
          'Oops! It looks like an error happened, please refresh your page or try again later.';
      }
    });
  }

  getContent(): void {
    this.apiService.getAemPage('link-card').subscribe(data => {
      this.aemContent = data;
      this.linkCardContent = JSON.parse(this.aemContent.linkCard);
      this.mobileImg = `${environment.API_URL}/getAemImage?image=${this.linkCardContent.images.mobile}`;
      this.desktopImg = `${environment.API_URL}/getAemImage?image=${this.linkCardContent.images.desktop}`;
    });
  }

  async setAnalytics() {
    try {
      const satelite = await (window as any)._satellite;
      const digitalData = await (window as any).digitalData;
      if (
        typeof satelite !== 'undefined' &&
        typeof digitalData !== 'undefined'
      ) {
        satelite.track('page-load');
      }
    } catch (error) {}
  }

  sendTrackingInfo(): void {
    this.digitalData = {
      pageInfo: {
        cardType: '',
        cardTypeOwned: '',
        loginType: '',
        offerID: '',
        pageName: 'addcard | public | gmb',
        pageSubType: '',
        pageType: 'addcard'
      }
    };
    this.digitalData = this.adobeDTMService.setupWindowPageInfoData(
      this.digitalData,
      'addcard',
      'addcard'
    );

    this.adobeDTMService.setWindowObjectData(this.digitalData);
    this.adobeDTMService.sendAdobeLaunchData();
  }
}
